export const isSiteInShellCookieName = "isSiteInShell";
export const contentModeCookieName = "cms_CurrentContentMode";
export const contentModeSignatureCookieName = "cms_CurrentContentModeSignature";
export const isMobileAppCookieName = "cms_IsMobileApp";

type ContentMode = "Viewing" | "Editing" | "Previewing";
export default ContentMode;
